import type {SVGProps} from 'react';
import * as React from 'react';

export const CollectionIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="1em"
		height="1em"
		fill="none"
		viewBox="0 0 24 24"
		{...props}
	>
		<path
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={1.8}
			d="M.75 14.25v9m0-1.5h16.5a3 3 0 0 0-3-3H10.5m0 0a3 3 0 0 0-3-3H.75m9.75 3H6.75m12-6a3 3 0 1 1-5.25-1.984m.75-5.516a4.5 4.5 0 1 0 9.002 0 4.5 4.5 0 0 0-9.002 0Z"
		/>
	</svg>
);
